import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { CloneAndConversionService as BaseCloneAndConversionService } from "../../../shared/services/cloneAndConversionService";
import { Machine } from "../../models/machine";
import { MachineConfiguration } from "../../models/machineConfiguration";
import { IQService } from "angular";
import {
  SobobaUtilsService,
  vsServiceName as SobobaUtilsServiceName,
} from "../../utils";

export const vsServiceName = "cloneAndConversionService";

export class CloneAndConversionService extends BaseCloneAndConversionService<
  Machine,
  MachineConfiguration
> {
  static $inject = [ServerUtilityName, "$q", SobobaUtilsServiceName];
  constructor(
    serverUtility: ServerUtility,
    $q: IQService,
    private readonly sobobaUtilsService: SobobaUtilsService
  ) {
    super(serverUtility, $q);
  }

  protected override prepareCloneConfiguration(
    cloneConfiguration: MachineConfiguration
  ): MachineConfiguration {
    return super.prepareCloneConfiguration(cloneConfiguration);
  }

  protected override prepareConversionConfiguration(
    conversionConfiguration: MachineConfiguration,
    currentConfiguration: MachineConfiguration
  ): MachineConfiguration {
    const result = super.prepareConversionConfiguration(
      conversionConfiguration,
      currentConfiguration
    );

    result.Eproms = result.Eproms = this.sobobaUtilsService.normalizeEproms(
      result.Eproms ?? []
    );

    const specificChanges = {
      PurchaseDate: currentConfiguration.PurchaseDate,
      ActiveDate: currentConfiguration.PurchaseDate,
      BankConfigId: currentConfiguration.BankConfigId,
      BankConfig: currentConfiguration.BankConfig,
      SlotNumber: currentConfiguration.SlotNumber,
      NumberOfReels: currentConfiguration.NumberOfReels,
      ButtonPanelId: currentConfiguration.ButtonPanelId,
      ButtonPanel: currentConfiguration.ButtonPanel,
      Date: undefined,
    };

    return {
      ...result,
      ...specificChanges,
    };
  }
}
